<template>
    <Modal :close_button="true" :size="'modal-md'" mid="confirm-delete-account">
        <template v-slot:header>{{$t('management_console.delete_account.title')}}</template>
        <template v-slot:body>
            <p>{{$t('management_console.delete_account.warning')}}</p>
            <ul>
                <li>{{$t('management_console.delete_account.orders')}}</li>
                <li>{{$t('management_console.delete_account.members')}}</li>
                <li>{{$t('management_console.delete_account.products')}}</li>
                <li>{{$t('management_console.delete_account.reports')}}</li>
                <li>{{$t('management_console.delete_account.subscriptions')}}</li>
            </ul>
            <div class="alert alert-danger mt-3" role="alert">
                {{$t('management_console.delete_account.scheduled_for')}} <strong>{{removal_date}}</strong>.
            </div>
            <div @click="agree = !agree" class="pe-pointer noselect">
                <BootstrapIcon v-if="agree" class="me-2 text-red-500 fill-red-500" name="check-square" :size="18" />
                <BootstrapIcon v-else class="me-2 text-red-500 fill-red-500" name="square" :size="18" />
                <span class="text-red-500 align-middle">{{$t('management_console.delete_account.agreement')}}</span>
            </div>
        </template>
        <template v-slot:footer>
            <button :disabled="!agree || loading" type="button" class="btn btn-danger bg-gradient px-4" @click="submit()">{{$t('management_console.delete_account.delete')}}</button>
            <button type="button" class="btn px-4" @click="cancel()">{{$t('controls.cancel')}}</button>
        </template>
    </Modal>
</template>

<script>
import Store from '@/common/store/user'
import BootstrapIcon from '@/common/directive/BootstrapIcon'
import DateFormat from 'date-fns/format'
import { enUS, ro } from 'date-fns/locale'

export default {
    components: {
        BootstrapIcon
    },
    data: function () {
        return {
            loading: false,
            agree: false,
            removal_date: null,
            removal_days: 10
        }
    },
    computed: {
        locale: function () {
            return this.$i18n.locale
        }
    },
    created: function () {
        const self = this
        const date = new Date()
        date.setDate(date.getDate() + this.removal_days)

        this.$bus.$on('Modal/shown/confirm-delete-account', function () {
            self.agree = false
            self.removal_date = DateFormat(date, 'dd MMM yyyy', { locale: self.locale === 'ro' ? ro : enUS }).toUpperCase()
        })
    },
    methods: {
        cancel: async function () {
            this.$bus.$emit('Modal/hide/confirm-delete-account')
        },
        submit: async function () {
            this.loading = true
            const response = await Store.dispatch('DELETE_ACCOUNT')
            if (response.status === 200) {
                if (response.data.status === 0) {
                    this.$bus.$emit('Notification/show', { title: this.$t('management_console.delete_account.removal_scheduled'), msg: this.$t('management_console.delete_account.removal_scheduled_description', { date: this.removal_date }), level: 'success' })
                    await this.$store.dispatch('GET_INFO')
                    this.$bus.$emit('Organization/info')
                    this.$bus.$emit('Modal/hide/confirm-delete-account')
                }
            } else if (response.status === 409) {
                this.$bus.$emit('Notification/show', { title: this.$t('management_console.delete_account.already_scheduled'), msg: this.$t('management_console.delete_account.already_scheduled_description'), level: 'danger' })
            } else {
                this.$bus.$emit('Notification/show', { title: this.$t('notifications.something_went_wrong'), msg: this.$t('notifications.please_retry_the_operation_or_refresh'), level: 'danger' })
            }
            this.loading = false
        }
    }
}
</script>
